/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const analyticAbcService = {
  getList: (params: any) => request.get('/analytic/abc', { params })
};

export default analyticAbcService;
